import { render, staticRenderFns } from "./ClientModules.vue?vue&type=template&id=6605ed62&"
import script from "./ClientModules.vue?vue&type=script&lang=js&"
export * from "./ClientModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports